import script from "./layout-header.vue?vue&type=script&setup=true&lang=js"
export * from "./layout-header.vue?vue&type=script&setup=true&lang=js"

import "./layout-header.vue?vue&type=style&index=0&id=283a8ff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-283a8ff0"]])

export default __exports__